import type { FoldingCardProp } from "@components/FoldingCardProp.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getBenefitsCrm(tenant: Tenant): FoldingCardProp[] {
	return [
		{
			title: "Lepší organizace dat o zákaznících",
			desc: "Všechny informace o klientech (historie interakcí, objednávky, kontaktní údaje atd.) budete mít na sp[[jednom místě.]]",
			bg: "bg-fstgrey-400",
		},
		{
			title: "Maximální flexibilita",
			desc: "Proč byste se měli přizpůsobovat krabicovému CRM, když vám ho můžeme nachystat sp[[na míru?]]",
			bg: "bg-fstgrey-500",
		},
		{
			title: "Zvýšení prodejů",
			desc: "CRM pomáhá sledovat obchodní příležitosti a zajišťuje, že vám sp[[neunikne žádný zajímavý lead.]]",
			bg: "bg-fstgrey-600",
		},
		{
			title: "Automatizace rutinních procesů",
			desc: "Co kdyby váš CRM systém sp[[automaticky]] odesílal e-maily, vytvářel úkoly nebo generoval reporty?",
			bg: "bg-fstgrey-700",
		},
		{
			title: "Lepší zákaznický servis",
			desc: "Podpora a obchodníci budou mít celou komunikaci se zákazníky pod kontrolou, takže sp[[zvládnou lépe řešit jejich požadavky.]]",
			bg: "bg-fstgrey-800",
		},
		{
			title: "Snadné škálování",
			desc: "Zajistíme, aby CRM systém sp[[rostl společně s vaším podnikáním.]] Kdykoliv ho můžeme rozšířit nebo optimalizovat.",
			bg: "bg-fstgrey-900",
		},
	];
}
